import request from '@/utils/request';

// 导出开票数据
export const invoiceExport = (values) => {
  return request('/activity-data/invoice/export', {
    method: 'POST',
    data: values,
    responseType: 'blob',
    getResponse: true,
  });
};
